const { lazy } = require('react')

const ChangePasswordPage = lazy(() => import('./ChangePasswordPage'))
const ProfilePage = lazy(() => import('./ProfilePage'))

export { ChangePasswordPage, ProfilePage }
